import React from 'react';

export enum MessageTypeId {
  ChatMessage = 'chatMessage',
  SignalIncident = 'signalIncident',
  Activity = 'activity',
  TriageRun = 'triageRun',
}

export enum ChildStatus {
  Loading = 'loading',
  Refetching = 'refetching',
  Ready = 'ready',
  Error = 'error',
  Timeout = 'timeout',
}

export interface TimelineEntry<TItem> {
  type: MessageTypeId;
  timestamp: string;
  item: TItem;
}

export interface MessageTypeRegistration<TItem> {
  id: MessageTypeId;
  Row: React.ComponentType<{ item: TItem }>;
  getKey: (item: TItem) => string;
  useItems: () => TimelineEntry<TItem>[];
  useReadiness: () => ChildStatus;
  useLoadMore?: () => (() => Promise<void>) | undefined;
  usePaginationState?: () => { hasMore: boolean; isLoadingMore: boolean };
  Provider?: React.ComponentType<{ children: React.ReactNode }>;
  blockingForInitialRender?: boolean;
  timeoutMs?: number;
}

export const MESSAGE_TYPE_IDS = [
  MessageTypeId.ChatMessage,
  MessageTypeId.SignalIncident,
  MessageTypeId.Activity,
  MessageTypeId.TriageRun,
] as const;
